import { CountryCode } from "../../../utils/CountryCode"

const countriesWhoUseImperialUnits = [CountryCode.United_States, CountryCode.Liberia, "MM"] as readonly string[]

export const getCountryUsesImperialUnits = (countryCode: string): boolean => {
  return countriesWhoUseImperialUnits.includes(countryCode)
}
